import { z } from 'zod'
import { sanitizeInput } from './sanitize'

const sanitizedString = (min?: number, max?: number) => {
  let schema = z.string()
  if (min !== undefined) schema = schema.min(min, `מינימום ${min} תווים`)
  if (max !== undefined) schema = schema.max(max, `מקסימום ${max} תווים`)
  return schema.transform(sanitizeInput)
}

export const productStatusSchema = z.enum(['active', 'sold_out', 'suspended', 'draft', 'other', 'sale'])
export const productUnitSchema = z.enum(['kg', 'unit', 'carton', 'pallet', 'container'])

export const productSchema = z.object({
  name:        sanitizedString(1, 100),
  description: sanitizedString(0, 1000).optional(),
  price:       z.number().min(0.01, 'מחיר חייב להיות גדול מ-0').max(999999),
  quantity:    z.number().int().min(0, 'כמות לא יכולה להיות שלילית').max(999999),
  unit:        productUnitSchema,
  category_id: z.string().uuid('יש לבחור קטגוריה').nullable(),
  status:      productStatusSchema,
  custom_sku: z.union([
    z.string().max(50, 'מק״ט לא יכול להיות ארוך מ-50 תווים'),
    z.null(),
    z.undefined()
  ]).optional(),
})

export const productUpdateSchema = productSchema.partial()

export type ProductInput = z.infer<typeof productSchema>
export type ProductUpdateInput = z.infer<typeof productUpdateSchema>